declare global {
  interface Window {
    consumeMagicToken?: (magicToken: string) => Promise<void>;
    consumeAuthResponse?: (authResponse: AuthResponseParams) => Promise<void>;
  }
}

/**
 *
 * @param cb
 */
export const onMagicTokenConsumed = (cb: Function) => {
  window.consumeMagicToken = async (magicToken: string) => {
    // alert(`window.consumeMagicToken ${magicToken}`);
    // post magicToken to SL API, if successful the API will set cookies on this browser
    // ...

    await cb();
  };
};

export const onAuthResponse = (
  cb: (authResponse: AuthResponseParams) => void,
) => {
  window.consumeAuthResponse = async (authResponse) => {
    await cb(authResponse);
  };
};

export const getMagicSessionUrlFor = (
  url: string,
  // Typescript will still let you pass any string (argggg) but typing for clarity
  loginToken: MagicLoginToken,
  host?: string,
) => {
  const hostname = host || useRuntimeConfig().public.STREAMLABS_API_BASE_PATH;

  return `${hostname}/slobs/magic/init-session?login_token=${loginToken}&r=${encodeURIComponent(url)}`;
};
